module.exports = {
      id: "default-card-image-usage",
      viewBox: "0 0 1024 683",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#default-card-image",
      toString: function () {
        return this.url;
      }
    }